import { createAction } from '@reduxjs/toolkit'

export const etherscanTxList = createAction<{ result: any }>('transient/etherscanTxList')
